module.exports = __webpack_public_path__ + "static/btn_dxzm_0110.467935b4.png";